import { render, staticRenderFns } from "./request-bank-statements-step.vue?vue&type=template&id=36c9e255"
import script from "./request-bank-statements-step.vue?vue&type=script&lang=js"
export * from "./request-bank-statements-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports